import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://quvalqszpnouallulojq.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InF1dmFscXN6cG5vdWFsbHVsb2pxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTE2OTk1ODYsImV4cCI6MjA2NzI3NTU4Nn0.qithKjA1CJSzuyclg11TCCmsXJ4N9HmMSX-HpH8c-mI'

if (SUPABASE_URL === 'https://your-project-id.supabase.co' || SUPABASE_ANON_KEY === 'your-anon-key') {
    throw new Error('Missing Supabase credentials')
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
    auth: {
        persistSession: true,
        autoRefreshToken: true,
    }
})

// Helper functions for community features
export const communityAPI = {
    // Get all posts with related data
    async getPosts({ category = null, sortBy = 'recent', searchQuery = '' } = {}) {
        let query = supabase
            .from('community_posts_ilm2024')
            .select(`
                *,
                author:author_id(*),
                comments:community_comments_ilm2024(count),
                reactions:community_reactions_ilm2024(*)
            `)
            .order('created_at', { ascending: false });

        if (category && category !== 'all') {
            query = query.eq('category', category);
        }

        if (searchQuery) {
            query = query.or(`title.ilike.%${searchQuery}%,content.ilike.%${searchQuery}%`);
        }

        if (sortBy === 'popular') {
            query = query.order('likes', { ascending: false });
        } else if (sortBy === 'comments') {
            // Sort by comment count
            query = query.order('comments.count', { ascending: false });
        }

        const { data, error } = await query;
        if (error) throw error;
        return data;
    },

    // Create a new post
    async createPost(post) {
        const { data, error } = await supabase
            .from('community_posts_ilm2024')
            .insert([{
                title: post.title,
                content: post.content,
                category: post.category,
                tags: post.tags,
                author_id: supabase.auth.user()?.id
            }])
            .select();

        if (error) throw error;
        return data[0];
    },

    // Get comments for a post
    async getComments(postId) {
        const { data, error } = await supabase
            .from('community_comments_ilm2024')
            .select(`
                *,
                author:author_id(*),
                reactions:community_reactions_ilm2024(*)
            `)
            .eq('post_id', postId)
            .order('created_at', { ascending: true });

        if (error) throw error;
        return data;
    },

    // Add a comment
    async addComment({ postId, content, parentId = null }) {
        const { data, error } = await supabase
            .from('community_comments_ilm2024')
            .insert([{
                post_id: postId,
                content,
                parent_id: parentId,
                author_id: supabase.auth.user()?.id
            }])
            .select();

        if (error) throw error;
        return data[0];
    },

    // Add a reaction
    async addReaction({ postId = null, commentId = null, emoji }) {
        const { data, error } = await supabase
            .from('community_reactions_ilm2024')
            .insert([{
                post_id: postId,
                comment_id: commentId,
                emoji,
                user_id: supabase.auth.user()?.id
            }])
            .select();

        if (error) throw error;
        return data[0];
    },

    // Remove a reaction
    async removeReaction({ postId = null, commentId = null, emoji }) {
        const { error } = await supabase
            .from('community_reactions_ilm2024')
            .delete()
            .match({
                post_id: postId,
                comment_id: commentId,
                emoji,
                user_id: supabase.auth.user()?.id
            });

        if (error) throw error;
    }
};

export default supabase;